module.exports = __webpack_public_path__ + "img/Tokyo-01.61d122af.jpg";